import { useDispatch, useSelector } from 'react-redux';

import {
  clearActivateCodeAction,
  clearActivatedCodeAction,
  clearRecoveryUserAction,
  clearStudentDetailAction,
  getEducational,
  setActivateCodeAction,
  setActivatedCodeAction,
  setRecoveryUserAction,
  setStudentDetailAction,
} from './redux/slice';
import {
  EducationalInstitutionActivatedCodeResponse,
  EducationalInstitutionStudentDetailResponse,
  EducationalInstitutionTryActivateCodeResponse,
} from './types';
import { EducationalInstitutionRecoverUserByActivationCodeResponse } from './types/EducationalInstitutionRecoverUserByActivationCodeResponse';

const useEducational = () => {
  const dispatch = useDispatch();

  const educational = useSelector(getEducational);

  const setActivateCode = (activateCode: EducationalInstitutionTryActivateCodeResponse, activationCode: string) => {
    dispatch(setActivateCodeAction({ activateCode, activationCode }));
  };

  const clearActivateCode = () => {
    dispatch(clearActivateCodeAction());
  };

  const setActivatedCode = (activatedCode: EducationalInstitutionActivatedCodeResponse) => {
    dispatch(setActivatedCodeAction(activatedCode));
  };

  const clearActivatedCode = () => {
    dispatch(clearActivatedCodeAction());
  };

  const setRecoveryUser = (activatedCode: EducationalInstitutionRecoverUserByActivationCodeResponse) => {
    dispatch(setRecoveryUserAction(activatedCode));
  };

  const clearRecoveryUser = () => {
    dispatch(clearRecoveryUserAction());
  };

  const setStudentDetail = (studentDetail: EducationalInstitutionStudentDetailResponse) => {
    dispatch(setStudentDetailAction(studentDetail));
  };

  const clearStudentDetail = () => {
    dispatch(clearStudentDetailAction());
  };

  return {
    ...educational,

    setActivateCode,
    clearActivateCode,

    setActivatedCode,
    clearActivatedCode,

    setRecoveryUser,
    clearRecoveryUser,

    setStudentDetail,
    clearStudentDetail,
  };
};

export default useEducational;
